export default __webpack_public_path__ + "static/media/C4.a6e67609.svg";